/**
 * Recupera tutti i risultati da endpoint DRF paginati (page-based).
 * Se la risposta non è paginata, restituisce direttamente l'array.
 */
export const fetchAllPaginatedResults = async (apiGetter, params = {}, maxPages = 100) => {
  const allResults = []
  let page = 1

  for (let i = 0; i < maxPages; i += 1) {
    const response = await apiGetter({ ...params, page })
    const payload = response?.data

    if (Array.isArray(payload)) {
      return payload
    }

    if (!payload || !Array.isArray(payload.results)) {
      return []
    }

    allResults.push(...payload.results)

    if (!payload.next) {
      return allResults
    }

    const nextPageRaw = new URL(payload.next, 'http://localhost').searchParams.get('page')
    const nextPage = Number.parseInt(nextPageRaw || '', 10)
    page = Number.isFinite(nextPage) && nextPage > 0 ? nextPage : page + 1
  }

  return allResults
}

